<template>
  <div v-show="!temToken" id="div-main">
    <!-- Modal de carregamento -->
    <v-dialog v-model="loading" persistent max-width="300px">
      <v-card color="primary" dark>
        <v-card-text class="d-flex flex-column align-center justify-center pa-8">
          <v-progress-circular indeterminate color="white" size="48" class="mb-4" />
          <span class="text-h6">Aguarde...</span>
          <small class="mt-2">Carregando processos disponíveis</small>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="main-init-flex">
      <template v-if="processos.length > 0">
        <div v-for="processo in processos" :key="processo.id" class="main-init-card-flex">
          <v-card elevation="8" class="pa-4 text-center card-flex main-init-card mx-auto">
            <div class="card-content-flex">
              <v-icon :color="processo.display ? 'primary' : 'info'" :size="56">{{ processo.icon_main }}</v-icon>
              <h2 class="mt-2 mb-2 font-weight-bold">{{ processo.titulo }}</h2>
              <p class="mb-4">{{ processo.chamada }}</p>
              <div class="card-spacer"></div>
              <v-btn
                :color="processo.display ? 'primary' : 'info'"
                large
                class="mt-2 card-bottom-btn"
                @click="selecionarUmProcesso(processo)"
              >
                <v-icon left>{{ processo.icon_btn }}</v-icon>
                {{ processo.label_btn }}
              </v-btn>
            </div>
          </v-card>
        </div>
      </template>
      <template v-else>
        <div v-if="vazio" class="main-init-card-flex">
          <v-card elevation="8" class="pa-4 text-center card-flex main-init-card mx-auto">
            <div class="card-content-flex">
              <v-icon color="grey" size="56">mdi-information-outline</v-icon>
              <h2 class="mt-2 mb-2 font-weight-bold">Nenhuma atividade disponível</h2>
              <p class="mb-4">
                No momento não há processos ou atividades institucionais ativos para sua participação.<br />Por favor,
                aguarde novas oportunidades ou entre em contato com a administração para mais informações.
              </p>
              <div class="card-spacer"></div>
            </div>
          </v-card>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "initPage",
  data: () => ({
    processos: [],
    loading: false,
    vazio: false,
  }),
  components: {},
  filters: {},
  computed: {
    temToken() {
      return !!localStorage.getItem("token");
    },
  },
  methods: {
    selecionarUmProcesso(processo) {
      this.$store.commit("ProcessosStore/setProcessoSelecionado", processo);
      this.$store.commit("remocao/setProcessoSelecionado", processo);
      this.$router.push(processo.route);
    },
    async carregarProcessos() {
      this.loading = true;
      try {
        this.processos = this.$store.getters["config/getProcessos"];

        if (this.processos.length === 0) {
          this.vazio = true;
        } else {
          this.vazio = false;
        }
        this.$nextTick(() => {
          this.setCardsSameHeight();
        });
      } catch (e) {
        this.processos = [];
      } finally {
        this.loading = false;
      }
    },
    setCardsSameHeight() {
      if (window.innerWidth < 801) {
        // Mobile: não força altura
        const cards = document.querySelectorAll(".main-init-card");
        cards.forEach((card) => {
          card.style.height = "";
        });
        return;
      }
      const cards = document.querySelectorAll(".main-init-card");
      let maxHeight = 0;
      cards.forEach((card) => {
        card.style.height = "";
        if (card.offsetHeight > maxHeight) {
          maxHeight = card.offsetHeight;
        }
      });
      cards.forEach((card) => {
        card.style.height = maxHeight + "px";
      });
    },
  },
  mounted: function () {
    this.carregarProcessos();
    this.$nextTick(() => {
      this.setCardsSameHeight();
      window.addEventListener("resize", this.setCardsSameHeight);
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.setCardsSameHeight);
  },
  beforeDestroy() {
    // Nenhum ajuste de altura necessário
  },
  watch: {
    // Nenhum ajuste de altura necessário
  },
};
</script>

<style scoped>
/* Responsividade e layout para initPage */
.main-init-container {
  max-width: 100vw;
  overflow-x: hidden;
}
.main-init-card {
  max-width: 420px;
  width: 100%;
  box-sizing: border-box;
}
@media (max-width: 600px) {
  .main-init-card {
    max-width: 98vw;
    padding: 8px !important;
  }
}
.v-card.card-flex {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  height: 100%;
}
.card-content-flex {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card-spacer {
  flex: 1 1 auto;
}
.card-bottom-btn {
  align-self: flex-center;
  margin-top: auto;
}
.v-card {
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  transition: height 0.2s;
}
.main-init-flex {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  min-height: 60vh;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 32px;
  width: 100%;
}
.main-init-card-flex {
  display: flex;
  justify-content: center;
  align-items: stretch;
  max-width: 420px;
  margin: 12px;
  width: auto;
}
@media (min-width: 801px) {
  .main-init-card-flex {
    height: 100%;
  }
  .main-init-flex {
    align-items: stretch;
  }
  .main-init-card {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
@media (max-width: 800px) {
  .main-init-flex {
    flex-direction: column;
    align-items: center;
    max-width: 98vw;
  }
  .main-init-card-flex {
    max-width: 98vw;
    width: 100%;
    margin: 8px 0;
  }
}
</style>
